
export interface ICenterFiveStarDetail {
    countOf1Star: number,
    countOf2Star: number,
    countOf3Star: number,
    countOf4Star: number,
    countOf5Star: number,
    centerAverage: number,
    centerAverageN: number,
    networkAverage: number,
    networkAverageN: number,
    networkDiff: number,
    hasBeenVoted: true
}
